import $ from 'jquery';
import Form from 'portlets/site/way/form/form';
import Prefixed from 'modules/prefixed/prefixed';

export default class {
	constructor(options) {
		const defaults = {
			el: '#yotaWay',
			dom: {
				promo: '#yotaWayPromo',
				form: '#yotaWayForm'
			}
		};

		this.options = $.extend(true, {}, defaults, options);
		this.$el = $(this.options.el);
		this.$window = $(window);
		this.prefixed = new Prefixed();
		return this;
	}

	getDom() {
		this.$promo = this.$el.find(this.options.dom.promo);
		this.$form = this.$el.find(this.options.dom.form);
		return this;
	}

	onScroll() {
		let delta = (550 - window.pageYOffset) / 550;
		if (delta < 0) {
			delta = 0;
		}
		this.$promo
			.css(this.prefixed.css.transform, 'scale(' + delta + ') translateZ(0)')
			.css('opacity', delta);
	}

	render() {
		if (this.$el.length) {
			this.getDom();
			this.form = new Form({el: this.$form}).render();
			this.$window.on('scroll resize', this.onScroll.bind(this)).trigger('resize');
		}
		return this;
	}
}



// WEBPACK FOOTER //
// ./app/portlets/site/way/way.js